/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Image } from 'react-bootstrap';
import { EventCard, IEventCardProps } from '../../EventCardWidget';

export type IEventItemProps = IEventCardProps;

export interface IEventsWidgetProps {
  title?: string;
  footerLink?: string;
  footerIcon?: string | any;
  footerText?: string;
  eventItems?: IEventItemProps[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const EventsWidget = ({
  title,
  footerIcon,
  footerText,
  footerLink,
  eventItems,
}: IEventsWidgetProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xs me-2"
          />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-xs me-2"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(<Icon key={`hero-icon-2`} className="icon icon-xs me-2" />);
    }
    return _icon;
  };
  const _renderEvents = () => {
    let _comp: any = [];
    if (eventItems) {
      eventItems?.forEach((event, index) => {
        _comp.push(
          <EventCard
            key={`event-item-${index}`}
            {...(event || {})}
            lastItem={eventItems?.length === index + 1}
          />
        );
      });
    }
    return _comp;
  };

  const _renderFooter = () => {
    if (footerText) {
      return (
        <Card.Footer
          as={Link}
          to={footerLink ?? '#'}
          className="border-top bg-gray-50"
        >
          <div className="d-flex align-items-center justify-content-center fw-bold">
            {_getIcon(footerIcon)}
            {footerText}
          </div>
        </Card.Footer>
      );
    }
  };
  if (title) {
    return (
      <>
        <Card border="0" className="shadow">
          <Card.Header className="border-bottom">
            <h2 className="fs-5 fw-bold mb-1">{title}</h2>
          </Card.Header>
          <Card.Body>{_renderEvents()}</Card.Body>
          {_renderFooter()}
        </Card>
      </>
    );
  }
};

EventsWidget.defaultProps = {};
